"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const object_1 = require("./utils/object");
const binary_1 = require("./binary");
const timeseries_1 = require("./timeseries");
/**
 * Resources can be saved as Picard binaries and must have a startTime, classifier and fixed interval
 */
class Resource extends timeseries_1.Timeseries {
    /**
     * Create an instance of Resource
     * @param resourceId Resource Id
     * @param classifier Data classifier
     * @param interval Fixed interval
     * @param startTime Time of first reading
     * @param dataType DataType to encode readings
     * @param data ArrayBuffer or JavaScript array
     */
    constructor(resourceId, classifier, interval, startTime, dataType, data = []) {
        // Determine the provided data length and timestamps
        const length = (0, object_1.isArrayBuffer)(data)
            ? data.byteLength / dataType.bytes
            : data.length;
        const timestamps = [];
        for (let i = 0; i < length; i++) {
            timestamps.push(startTime + interval * i);
        }
        // Initialise Timeseries with single Series
        super(timestamps, [new timeseries_1.Series(resourceId, dataType, data)], interval);
        this.classifier = classifier;
        this.startTime = startTime;
        this.resourceId = resourceId;
        this.classifier = classifier;
    }
    /**
     * Change the Resource's Timeseries data
     * @param timestamps New list of timestamps
     * @param series New series
     */
    updateTimeseries(timestamps, series) {
        this._init(timestamps, [series]);
    }
    get interval() {
        if (this._interval === null) {
            throw new Error("Resource should have fixed interval");
        }
        return this._interval;
    }
    get dataType() {
        return this.series().dataType;
    }
    get endTime() {
        return this.startTime + this.count * this.interval;
    }
    static fromArrayBuffer(resourceId, arrayBuffer) {
        return (0, binary_1.decode)(resourceId, arrayBuffer);
    }
    toArrayBuffer() {
        return (0, binary_1.encode)(this);
    }
}
exports.default = Resource;
//# sourceMappingURL=resource.js.map